import useMembership from 'hooks/useMembership';

export default function useOrganizationModules(requestedModules) {
  const [membership] = useMembership();
  const organizationModule = membership ? membership.organization.modules : [];

  return requestedModules.map((m) => organizationModule.includes(m));
}
